import styled from 'styled-components'

import { IconV2 } from '../../Icon'

export const ContainerPrimary = styled(IconV2)`
  color: var(--theme-colors-theme-brand-primary);
`

export const ContainerWarning = styled(IconV2)`
  color: var(--theme-colors-theme-warning-main);
`

export const ContainerNegative = styled(IconV2)`
  color: var(--theme-colors-theme-negative-main);
`

export const ContainerDefault = styled(IconV2)`
  color: var(--theme-colors-global-grey-grey500);
`

export const ContainerWhite = styled(IconV2)`
  color: var(--theme-colors-global-general-main);
`

export const ContainerGrey = styled(IconV2)`
  color: var(--theme-colors-global-grey-grey700);
`

export const ContainerNone = styled(IconV2)`
  color: transparent;
  svg {
    width: 20px;
    height: 20px;
  }
`
